<template>
  <section class="event-edit-page">
    <v-progress-linear
      v-if="isLoadingEvent"
      indeterminate
    />

    <AppPageTitleBar
      :title="pageTitle"
      :back-to="{ name: 'event-detail', params: { eventId } }"
      back-label="Natrag"
    />

    <EventForm
      v-if="eventToEdit"
      form-id="event-edit-form"
      :initial-event-values="eventToEdit"
      submit-text="Shrani događaj"
      :is-saving-event="isSavingEvent"
      @submit="saveEventChangesAsync"
    />
  </section>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import AppPageTitleBar from '../../components/AppPageTitleBar.vue'
import EventForm from '../../components/EventForm.vue'
import { apiClient } from '../../services/apiClient'
import { showErrorToast, showRequestErrorToast, showSuccessToast } from '../../store/appStore'

const route = useRoute()
const router = useRouter()

const eventId = computed(() => route.params.eventId)
const pageTitle = computed(() => route.meta.title)
const isLoadingEvent = ref(false)
const isSavingEvent = ref(false)
const eventToEdit = ref(null)

onMounted(loadEventToEditAsync)

async function loadEventToEditAsync () {
  isLoadingEvent.value = true

  try {
    const event = await apiClient.getAsync(`/api/events/${eventId.value}`)

    if (event.isArchived) {
      showErrorToast('Arhivirani događaj nije moguće uređivati.')
      await router.replace({
        name: 'event-detail',
        params: { eventId: event.id },
      })
      return
    }

    eventToEdit.value = event
  } catch (error) {
    console.error('Failed to load event for editing.', error)
    showRequestErrorToast(error, 'Događaj nije bilo moguće učitati.')
  } finally {
    isLoadingEvent.value = false
  }
}

async function saveEventChangesAsync (eventFormValues) {
  if (isSavingEvent.value) {
    return
  }

  isSavingEvent.value = true

  try {
    const updatedEvent = await apiClient.postAsync(`/api/events/${eventId.value}`, eventFormValues)
    const removedVehiclePlates = updatedEvent.removedVehicles
      ?.map((removedVehicle) => removedVehicle.vehiclePlate)
      .join(', ')

    showSuccessToast(
      removedVehiclePlates
        ? `Događaj je spremljen, ali su neka vozila uklonjena jer su već rezervirana za drugi događaj: ${removedVehiclePlates}.`
        : 'Događaj je uspješno spremljen.'
    )

    await router.push({
      name: 'event-detail',
      params: {
        eventId: updatedEvent.id,
      },
    })
  } catch (error) {
    console.error('Failed to update event.', error)
    showRequestErrorToast(error, 'Događaj nije bilo moguće spremiti.')
  } finally {
    isSavingEvent.value = false
  }
}
</script>
